import sanitizeHtml from 'sanitize-html';
import { IScript } from '../../shared/types/script';

export const escapeHtml = (unsafe: string) => {
  const safe = unsafe || '';

  return safe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

export const unescapeHtml = (unsafe: string) => {
  const safe = unsafe || '';

  return safe.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#39;/g, "'");
};

export const makeHTMLFromString = (content: string) => {
  const markup = unescapeHtml(content);
  const scripts = [];
  const pattern = /<script.*?(?:src="(.*?)")?>(.*?)<\/script>/gi;

  let match;
  while ((match = pattern.exec(markup)) != null) {
    scripts.push({
      body: match[0],
      src: match[1],
      content: match[2],
    });
  }

  let text = markup;
  scripts.forEach((script: IScript) => {
    text = text.replace(script.body, '');
  });

  return {
    __html: sanitizeHtml(text, {
      allowedTags: [
        'dl',
        'dt',
        'dd',
        'h2',
        'h3',
        'p',
        'i',
        'tbody',
        'br',
        'em',
        'td',
        'a',
        'strong',
        'th',
        'img',
        'strike',
        'tr',
        'div',
        'u',
        'caption',
        'span',
        's',
        'colgroup',
        'ul',
        'span',
        'col',
        'li',
        'pre',
        'tfoot',
        'ol',
        'table',
        'code',
        'b',
        'thead',
        'iframe',
        'button',
        'figure',
        'figcaption',
        'link',
        'hr',
      ],
      allowedAttributes: {
        '*': [
          'id',
          'itemscope',
          'itemtype',
          'itemprop',
          'href',
          'align',
          'alt',
          'center',
          'bgcolor',
          'class',
          'src',
          'rel',
          'target',
          'style',
          'name',
          'data-*',
          'rowspan',
          'colspan',
        ],
        iframe: ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen'],
        link: ['href', 'rel', 'type', 'media'],
      },
      allowedIframeHostnames: [
        'www.youtube.com',
        'cdn.embedly.com',
        'yandex.ru',
        'www.instagram.com',
        'www.facebook.com',
      ],
    }),
    scripts,
  };
};

const linkTemplate = /^(http:\/\/|https:\/\/)/;

const getlink = (href: string): string => `<a href="${href}" target="_blank" rel="nofollow noopener">${href}</a>`;

export const getCleanText = (dirtyText: string): string => {
  let textWithLinks = unescapeHtml(dirtyText);

  textWithLinks = textWithLinks
    .split(' ')
    .map(item => {
      return linkTemplate.test(item) ? getlink(item) : item;
    })
    .join(' ');

  return sanitizeHtml(textWithLinks, {
    allowedTags: ['a', 'br'],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
    },
  });
};
